// extracted by mini-css-extract-plugin
export default {"Container":"HelpSupport_Container__aiBug","back-btn":"HelpSupport_back-btn__SeJb7"};